import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { CookieConsent } from "@/components/CookieConsent";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Impressum from "@/pages/legal/Impressum";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import TermsOfUse from "@/pages/legal/TermsOfUse";
import CookiePolicy from "@/pages/legal/CookiePolicy";
import BookingPolicy from "@/pages/legal/BookingPolicy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/pravila-privatnosti" element={<PrivacyPolicy />} />
            <Route path="/uvjeti-koristenja" element={<TermsOfUse />} />
            <Route path="/kolacici" element={<CookiePolicy />} />
            <Route path="/pravila-rezervacije" element={<BookingPolicy />} />
          </Routes>
          <CookieConsent />
          <Toaster
            position="top-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#061A12",
                border: "1px solid rgba(201, 168, 106, 0.35)",
                color: "#F5EFE3",
                borderRadius: 0,
                fontFamily: "Manrope, sans-serif",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
